<template>
  <a v-on:click="logout()" class="dropdown-item">{{t('logout')}}</a>
</template>


<script>
import store from '../../store';

export default {
  name: 'UserLogout',
  methods: {
    logout() {
      store.commit('logout');
      // this.$router.push(`/${this.$store.state.language}/login`);
    },
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// Logout.vue?4c848df2